<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'ATTRIBUTES.LIST_OF_VALIDATORS' | translate }} 111</div>
                <div class="tools">
                     <button type="button" class="btn btn-primary btn-sm" [disabled]="!checkedCheckBox()"
                        (click)="deleteSelected()">
                        <i class="bi bi bi-trash"></i>{{ 'DELETE_SELECTED' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()">
                        <i class="bi bi-plus-circle"></i> {{ 'ADD' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_preset_all"
                                        id="select_preset_all" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_preset_all"></label>
                                </div>
                            </th>
                            <th scope="col" class="name">{{ 'NAME' | translate }}</th>
                            <!-- <th scope="col" class="name">Условие</th> -->
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="validators && validators.length > 0">
                        <tr *ngFor="let validator of validators; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_validator_{{ i }}"
                                        id="select_validator_{{ i }}" [checked]="validator.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_validator_{{ i }}"></label>
                                </div>
                            </td>
                            <td class="name">{{validator.name}}</td>
                            <!-- <td class="condtitions">
                                <div *ngIf="(validator.conditions | json) != '{}' && validator.conditions[selectedOperatorsForCondition].length > 0">
                                    <div *ngFor="let c of validator.conditions.AND">
                                        {{conditionsName(c.attribute_id)}}
                                    </div>
                                </div>
                            </td> -->
                            <td class="action">
                                <button type="button" class="btn btn-light" 
                                    placement="top" ngbTooltip="{{ 'EDIT' | translate }}" (click)="onEdit(validator.id)">
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                                <button type="button" class="btn btn-light" (click)="onConfirm([validator.id])"
                                    placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="!validators || validators.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="5">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="5">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>
    </div>
</div>